import BaseScreenProvider from "../services/BaseScreenProvider";

export class Template900ScreenProvider extends BaseScreenProvider {
    // 0-767
    // 768-1023
    // 1024+
    detectScreen() {
        if (matchMedia("only screen and (min-width: 1024px)").matches) {
            return 1024;
        }
        if (matchMedia("only screen and (min-width: 768px)").matches) {
            return 768;
        }

        return 320;
    }
}

export default new Template900ScreenProvider();
